<div class="program-step-container">
  <div class="program-step-container__items">
    <ng-container *ngFor="let block of groupedSteps; let gi = index">
      <!-- SINGLE -->
      <ng-container *ngIf="block.kind === 'single'">
        <ng-container [ngSwitch]="block.node.type">
          <div
            class="program-step-container__start-item card"
            *ngIf="block.node.type === 'start'"
          >
            <h4 [innerHTML]="block.node?.title"></h4>
            <span>{{ block.node?.description }}</span>
          </div>

          <mec-program-number
            class="program-step-container__item"
            *ngSwitchCase="'number'"
            id="node{{ block.originalIndex }}"
            (onSelectItemChange)="
              validateNode(gi, $event.programLog, $event.valid)
            "
            [programNode]="block.node"
          ></mec-program-number>

          <mec-program-radio
            class="program-step-container__item"
            *ngSwitchCase="'radio'"
            id="node{{ block.originalIndex }}"
            (onSelectItemChange)="validateNode(gi, $event, true)"
            [programNode]="block.node"
          ></mec-program-radio>

          <mec-program-policy
            class="program-step-container__item"
            *ngSwitchCase="'policy'"
            id="node{{ block.originalIndex }}"
            (onSelectItemChange)="
              validateNode(gi, $event.programLog, $event.valid)
            "
            [programNode]="block.node"
          ></mec-program-policy>

          <mec-program-checkbox
            class="program-step-container__item"
            *ngSwitchCase="'checkbox'"
            id="node{{ block.originalIndex }}"
            (onSelectItemChange)="validateNode(gi, $event, $event.valid)"
            [programNode]="block.node"
          >
          </mec-program-checkbox>

          <mec-program-open-text
            class="program-step-container__item"
            *ngSwitchCase="'openText'"
            id="node{{ block.originalIndex }}"
            (onSelectItemChange)="
              validateNode(gi, $event.programLog, $event.valid)
            "
            [programNode]="block.node"
          ></mec-program-open-text>

          <mec-program-list-input
            class="program-step-container__item"
            *ngSwitchCase="'list-input'"
            id="node{{ block.originalIndex }}"
            (onSelectItemChange)="
              validateNode(gi, $event.programLog, $event.valid)
            "
            [programNode]="block.node"
          ></mec-program-list-input>

          <mec-program-text
            class="program-step-container__item"
            *ngSwitchCase="'text'"
            id="node{{ block.originalIndex }}"
            (onSelectItemChange)="
              validateNode(gi, $event.programLog, $event.valid)
            "
            [programNode]="block.node"
          ></mec-program-text>

          <mec-program-date
            class="program-step-container__item"
            *ngSwitchCase="'date'"
            id="node{{ block.originalIndex }}"
            (onSelectItemChange)="
              validateNode(gi, $event.programLog, $event.valid)
            "
            [programNode]="block.node"
          ></mec-program-date>

          <mec-program-output
            class="program-step-container__item"
            *ngSwitchCase="'output'"
            id="node{{ block.originalIndex }}"
            [logs]="logs"
            [programNode]="block.node"
            [programToken]="programToken"
            [dependecies]="dependecies"
          ></mec-program-output>

          <mec-program-arithmetic
            class="program-step-container__item hidden"
            *ngSwitchCase="'arithmetic'"
            id="node{{ block.originalIndex }}"
            [logs]="logs"
            [programNode]="block.node"
            [programToken]="programToken"
          ></mec-program-arithmetic>

          <mec-program-media
            class="program-step-container__item"
            *ngSwitchCase="'media'"
            id="node{{ block.originalIndex }}"
            (onSelectItemChange)="
              validateNode(gi, $event.programLog, $event.valid)
            "
            [programNode]="block.node"
          ></mec-program-media>

          <mec-program-eqvas
            class="program-step-container__item"
            *ngSwitchCase="'eqvas'"
            (onSelectItemChange)="validateNode(gi, $event, true)"
            id="node{{ block.originalIndex }}"
            [programNode]="block.node"
          ></mec-program-eqvas>
        </ng-container>
      </ng-container>

      <!-- GROUP (MATRIX_RADIO) -->
      <ng-container *ngIf="block.kind === 'group'">
        <!-- passamos a lista inteira de nodes -->
        <mec-program-matrix-radio
          class="program-step-container__item"
          [nodes]="block.nodes"
          id="node{{ block.startIndex }}"
          (onSelectItemChange)="validateNode(gi, $event, $event.valid)"
        ></mec-program-matrix-radio>
      </ng-container>
    </ng-container>
  </div>
</div>
